var emptyErrorsFromInputs = (inputs) => {
    var errors = {};
    Object.keys(inputs).forEach(i => {
        errors[i] = [];
    });
    return errors;
};

export default class Validator {
    constructor(inputs) {
        if(! Object.keys(inputs).length) {
            throw new Error('No inputs provided');
        }
        this.inputs = inputs;
        this.errors = emptyErrorsFromInputs;
    }
    passes() {
        // reset errors, protect against being called twice and validation errors already having validation messages
        this.errors = emptyErrorsFromInputs(this.inputs);
        var passes = true;

        Object.keys(this.inputs).forEach(inputKey => {
            if(this.inputs[inputKey].validators) {
                this.inputs[inputKey].validators.forEach(validator => {
                    var isValid = validator.rule(this.inputs[inputKey].value, this.inputs);
                    if(! isValid) {
                        passes = false;
                        this.errors[inputKey].push(validator.errorMessage);
                    }
                });
            }
        });

        return passes;
    }
    getErrors() {
        // reset errors, protect against being called twice and validation errors already having validation messages
        this.errors = emptyErrorsFromInputs(this.inputs);
        Object.keys(this.inputs).forEach(inputKey => {
            if(this.inputs[inputKey].validators) {
                this.inputs[inputKey].validators.forEach(validator => {
                    var isValid = validator.rule(this.inputs[inputKey].value, this.inputs);
                    if (!isValid) {
                        this.errors[inputKey].push(validator.errorMessage);
                    }
                });
            }
        });

        return this.errors;
    }
}

module.exports = Validator;


// WEBPACK FOOTER //
// ./app/assert/Validator.js